import {ChangeDetectionStrategy, Component, Inject} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MAT_DIALOG_DATA, MatDialogModule, MatDialogRef} from '@angular/material/dialog';
import {StationerySelectorComponent} from '@settings/components/briefpapier/stationery-selector/stationery-selector.component';
import type {PublicProfileStationeryTemplate} from '@settings/models/publicProfile.settings.interface';
import {VAT_EXPORT_COPY} from '../../vat-copy';

export interface VatStationeryDialogData {
    templates: PublicProfileStationeryTemplate[];
    ownerId: string;
    activeLetterheadType?: string;
}

/**
 * Briefpapier für die Anlagen des Vordruck-PDFs (A6): StationerySelectorComponent mit filterScope 'LETTER',
 * Owner = Eigentümer. Schließt mit der gewählten Vorlage oder null („Ohne Briefpapier“).
 *
 * @author Anthony Nahas
 * @since 11.09.26
 */
@Component({
    selector: 'vat-stationery-dialog',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatDialogModule, MatButtonModule, StationerySelectorComponent],
    template: `
        <h2 mat-dialog-title class="text-lg font-semibold">{{ copy.title }}</h2>
        <mat-dialog-content class="flex flex-col gap-4">
            <p class="text-secondary text-md">{{ copy.text }}</p>
            <app-stationery-selector
                [templates]="data.templates"
                [ownerId]="data.ownerId"
                [filterScope]="'LETTER'"
                [activeLetterheadType]="data.activeLetterheadType"
                (selectionChange)="selected = $event">
            </app-stationery-selector>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
            <button mat-stroked-button type="button" (click)="dialogRef.close(null)">{{ copy.withoutStationery }}</button>
            <button mat-flat-button color="primary" type="button" (click)="dialogRef.close(selected)">{{ copy.apply }}</button>
        </mat-dialog-actions>
    `
})
export class VatStationeryDialogComponent {
    readonly copy = VAT_EXPORT_COPY.stationeryDialog;
    selected: PublicProfileStationeryTemplate | null = null;

    constructor(
        public dialogRef: MatDialogRef<VatStationeryDialogComponent, PublicProfileStationeryTemplate | null>,
        @Inject(MAT_DIALOG_DATA) public data: VatStationeryDialogData,
    ) {
    }
}
